'use client'
import {
  Spinner_default
} from "./chunk-K2IT7DRF.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/Button/Button.tsx
import { twMerge } from "tailwind-merge";

// src/Button/Button.classes.tsx
var BUTTON_CLASSES = {
  solid: {
    primary: "bg-primary hover:bg-primary-400 active:bg-primary-600 text-primary-contrast disabled:bg-input-disabled",
    secondary: "bg-secondary hover:bg-secondary-400 active:bg-secondary-600 text-secondary-contrast disabled:bg-input-disabled",
    tertiary: "bg-tertiary hover:bg-tertiary-400 active:bg-tertiary-600 text-tertiary-contrast disabled:bg-input-disabled",
    action: "bg-action hover:bg-action-400 active:bg-action-600 text-action-contrast disabled:bg-input-disabled",
    error: "bg-error hover:bg-error-400 active:bg-error-600 text-error-contrast disabled:bg-input-disabled",
    success: "bg-success hover:bg-success-400 active:bg-success-600 text-success-contrast disabled:bg-input-disabled",
    white: "bg-body-dark hover:bg-body-dark/90 active:bg-body-dark text-body-light disabled:bg-input-disabled",
    black: "bg-body-light hover:bg-body-light/90 active:bg-body-light text-body-dark disabled:bg-input-disabled",
    transparent: "bg-transparent text-text disabled:bg-input-disabled"
  },
  outlined: {
    primary: "border border-primary hover:bg-primary-400/20 active:bg-primary/30 text-primary disabled:bg-input-disabled/30",
    secondary: "border border-secondary hover:bg-secondary-400/20 active:bg-secondary/30 text-secondary disabled:bg-input-disabled/30",
    tertiary: "border border-tertiary hover:bg-tertiary-400/20 active:bg-tertiary/30 text-tertiary disabled:bg-input-disabled/30",
    action: "border border-action hover:bg-action-400/20 active:bg-action/30 text-action disabled:bg-input-disabled/30 disabled:border-input-disabled",
    error: "border border-error hover:bg-error-400/20 active:bg-error/30 text-error disabled:bg-input-disabled/30",
    success: "border border-success hover:bg-success-400/5 active:bg-success-400/10 text-success-600 disabled:bg-input-disabled/30",
    white: "border border-body-dark hover:bg-body-dark/5 active:bg-body-dark/10 text-body-dark disabled:bg-input-disabled/30 disabled:border-input-disabled",
    black: "border border-body-light hover:bg-body-light/5 active:bg-body-dark/10 text-body-light disabled:bg-input-disabled/30",
    transparent: "border border-transparent text-body-dark"
  },
  text: {
    primary: "hover:bg-primary-400/5 active:bg-primary-400/10 text-primary disabled:bg-input-disabled/10",
    secondary: "hover:bg-secondary-400/5 active:bg-secondary-400/10 text-secondary disabled:bg-input-disabled/10",
    tertiary: "hover:bg-tertiary-400/5 active:bg-tertiary-400/10 text-tertiary disabled:bg-input-disabled/10",
    action: "hover:bg-action-400/5 active:bg-action-400/10 text-action disabled:bg-input-disabled/10",
    error: "hover:bg-error-400/5 active:bg-error-400/10 text-error disabled:bg-input-disabled/10",
    success: "hover:bg-success-400/5 active:bg-success-400/10 text-success disabled:bg-input-disabled/10",
    white: "hover:bg-body-dark/5 active:bg-body-dark/10 text-body-dark disabled:bg-input-disabled/10",
    black: "hover:bg-body-light/5 active:bg-body-dark/10 text-body-light disabled:bg-input-disabled/10",
    transparent: "text-text disabled:bg-input-disabled/10"
  }
};
var BUTTON_SHADOW_CLASSES = {
  S: "shadow-sm",
  M: "shadow-md",
  L: "shadow-lg"
};

// src/Button/Button.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var MainButton = (_a) => {
  var _b = _a, {
    children,
    as,
    theme = "primary",
    shape = "solid",
    loading,
    disabled,
    shadow,
    className = "",
    arrow,
    arrowColor,
    rounded = true,
    phill = false,
    shiny,
    queueProtected,
    overloads = {},
    ref
  } = _b, props = __objRest(_b, [
    "children",
    "as",
    "theme",
    "shape",
    "loading",
    "disabled",
    "shadow",
    "className",
    "arrow",
    "arrowColor",
    "rounded",
    "phill",
    "shiny",
    "queueProtected",
    "overloads",
    "ref"
  ]);
  var _a2;
  const isQueue = queueProtected;
  const Component = disabled ? "button" : isQueue ? "a" : as || "button";
  return /* @__PURE__ */ jsxs(
    Component,
    __spreadProps(__spreadValues(__spreadValues({
      className: twMerge(
        BUTTON_CLASSES[shape][theme],
        (_a2 = overloads == null ? void 0 : overloads[shape]) == null ? void 0 : _a2[theme],
        "relative inline-flex items-center justify-center gap-1 overflow-hidden px-4 py-2 text-center transition",
        "disabled:text-text-disabled disabled:cursor-not-allowed",
        phill ? "rounded-full" : rounded ? "rounded-S" : "",
        shadow ? BUTTON_SHADOW_CLASSES[shadow] : "",
        className
      ),
      disabled: loading || disabled
    }, props), { href: props.to || props.href, to: props.to || props.href }), {
      ref,
      children: [
        shiny && /* @__PURE__ */ jsx("div", { className: "animate-shiny-rippon rtl:animate-shiny-rippon-rtl absolute inset-0 -top-1/4 h-28", children: /* @__PURE__ */ jsx("div", { className: "absolute inset-0 h-14 -rotate-45 bg-gradient-to-b from-white/10 via-white/50 to-white/10" }) }),
        loading && /* @__PURE__ */ jsx(Spinner_default, {}),
        " ",
        children,
        arrow && /* @__PURE__ */ jsx(
          "svg",
          {
            width: "18",
            height: "18",
            viewBox: "0 0 32 32",
            fill: "none",
            className: "shrink-0 ltr:rotate-180",
            children: /* @__PURE__ */ jsx(
              "path",
              {
                d: "M20.9426 8.94263C21.4633 8.42194 21.4633 7.57772 20.9426 7.05703C20.4219 6.53633 19.5777 6.53633 19.057 7.05703L11.057 15.057C10.5523 15.5618 10.5346 16.3745 11.017 16.9007L18.3503 24.9007C18.8478 25.4435 19.6913 25.4802 20.2341 24.9826C20.7769 24.485 20.8136 23.6416 20.316 23.0988L13.8453 16.0399L20.9426 8.94263Z",
                fill: arrowColor || "currentColor"
              }
            )
          }
        )
      ]
    })
  );
};
var Button_default = MainButton;

// src/Button/Button.types.tsx
var BUTTON_THEMES = [
  "primary",
  "secondary",
  "tertiary",
  "error",
  "success",
  "action",
  "white",
  "black",
  "transparent"
];
var BUTTON_SHAPES = ["solid", "outlined", "text"];

export {
  Button_default,
  BUTTON_THEMES,
  BUTTON_SHAPES
};
//# sourceMappingURL=chunk-EGOGHW2A.mjs.map